
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getAll(data=null) {
        const queryString = new URLSearchParams(data).toString();
        const url = `${API_URL}/remissions-details?${queryString}`; 

        return axios.get(url, { headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/remissions-details/${id}`, { headers: authHeader() });
    },
    createData(data) {

        // Obtener el user_id desde el localStorage
        let userId = JSON.parse(localStorage.getItem('user'));

        // Validar el user_id
        if (!userId || !userId.id) {
            throw new Error("User ID no válido. Asegúrate de haber iniciado sesión.");
        }

        data.user_id = userId.id;
        
        return axios.post(`${API_URL}/remissions-details`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/remissions-details/${id}`, data, { headers: authHeader() });
    },
    // Picking: sin data escanea una unidad; con { quantity: n } fija el valor exacto.
    pick(id, data = {}) {
        return axios.post(`${API_URL}/remissions-details/${id}/pick`, data, { headers: authHeader() });
    },
    // Reinicia el picking de todos los detalles de una remisión.
    resetPicking(remissionId) {
        return axios.post(`${API_URL}/remissions-details/${remissionId}/reset-picking`, {}, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/remissions-details/${id}`, { headers: authHeader() });
    }
};
